import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const ADD_STATEMENT_INTERESTS_HOLD = gql`
  mutation AddStatementInterestsHold($consultantUuid: ID!, $request: StatementInterestsHoldInputDto!) {
    addStatementInterestsHold(consultantUuid: $consultantUuid, request: $request) {
      uuid
      consultantUuid
      startDate
      endDate
      comment
      createdAt
      updatedAt
    }
  }
`;

export const useAddStatementInterestsHold = () => {
  const [addStatementInterestsHold, { loading, error, data }] = useMutation(ADD_STATEMENT_INTERESTS_HOLD);

  return {
    addStatementInterestsHold,
    loading,
    error,
    data: data?.addStatementInterestsHold,
  };
};

export default useAddStatementInterestsHold;
